// ComingSoon.jsx
import { FiClock, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "./ComingSoon.css";

export default function ComingSoon({ darkMode }) {
  const navigate = useNavigate();

  return (
    <div className={`coming-soon-container ${darkMode ? 'dark' : ''}`}>
      <div className="coming-soon-content">
        <button 
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          <FiArrowLeft size={18} />
          Back
        </button>
        
        <div className="coming-soon-icon">
          <FiClock size={48} />
        </div>
        
        <h1>Coming Soon</h1>
        <p>This feature is currently under development.</p>
        <p className="coming-soon-subtext">
          We're working hard to bring you this functionality.
        </p>
        
        <div className="coming-soon-progress">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: '65%' }}></div>
          </div>
          <span className="progress-text">65% Complete</span>
        </div>
      </div>
    </div>
  );
}